import * as z from 'zod';

// UAE mobile number validation regex
const uaePhoneNumberRegex =
  /^(?:\+971\s?5[0-9]{1}\s?[0-9]{3}\s?[0-9]{4}|05[0-9]{1}\s?[0-9]{3}\s?[0-9]{4})$/;

export const resortBookingSchema = z.object({
  customerName: z.string().min(1, "Name is required"),
  phone: z
    .string()
    .regex(
      uaePhoneNumberRegex,
      "Phone number must be a valid UAE mobile number (e.g., +971 50 123 4567 or 050 123 4567)"
    ),
  email: z.string().email("Invalid email"),

  adultsNumber: z
    .number({ invalid_type_error: "Adults number must be a number" })
    .min(1, "At least 1 adult is required")
    .max(9, "No more than 9 adults"),

  childrenNumber: z
    .number({ invalid_type_error: "Children number must be a number" })
    .min(0, "Children can't be less than 0")
    .max(9, "No more than 9 children"),

  serviceId: z.string().uuid("Invalid service ID format").optional(),
  totalPrice: z.number().nullable().optional(),

  checkInDate: z.string().nonempty("Check-in date is required"),
checkOutDate: z.string().nonempty("Check-out date is required"),
checkInTime: z.string().nonempty("Check-in time is required"),
checkOutTime: z.string().nonempty("Check-out time is required"),


});

export type ResortBookingSchema = z.infer<typeof resortBookingSchema>;
